mutation StartPoll($pollId: ID!) {
  poll: StreamToolsStartPoll(pollId: $pollId) {
    pollId
    status
    youtubeVotesEnabled
    startedAt
  }
}
